const IpProjectIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.3333 11.3327V12.666C11.3333 13.0196 11.1929 13.3588 10.9428 13.6088C10.6928 13.8589 10.3536 13.9993 10 13.9993H3.33333C2.97971 13.9993 2.64057 13.8589 2.39052 13.6088C2.14048 13.3588 2 13.0196 2 12.666V6.66602C2 6.31239 2.14048 5.97326 2.39052 5.72321C2.64057 5.47316 2.97971 5.33268 3.33333 5.33268H4.66667M6 2.66602H8L9.33333 3.99935H12.6667C13.0203 3.99935 13.3594 4.13982 13.6095 4.38987C13.8595 4.63992 14 4.97906 14 5.33268V9.99935C14 10.353 13.8595 10.6921 13.6095 10.9422C13.3594 11.1922 13.0203 11.3327 12.6667 11.3327H6C5.64638 11.3327 5.30724 11.1922 5.05719 10.9422C4.80714 10.6921 4.66667 10.353 4.66667 9.99935V3.99935C4.66667 3.64573 4.80714 3.30659 5.05719 3.05654C5.30724 2.80649 5.64638 2.66602 6 2.66602Z"
			stroke="#1A0638"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default IpProjectIcon;
